import * as React from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, useHistory } from "react-router";
import { agent } from "../agent";
import ConfirmTransition from "../pages/ConfirmTransition";
import { URL_PATHS } from "../routes";
import { AppState } from "../store";
import { myDataActions } from "../store/myData";
import { paymentActions } from "../store/payment";
import dayjs from "dayjs";
import { DATE_FORMAT } from "../shared/date-format";
import { PAYMENT_PLANS } from "../generated/lib-domain/paymentPlan";
import { PaymentType } from "../generated/lib-domain/paymentZeus";
import { PaymentMethodEnum } from "../generated/UserAPIAgent";
import { smartAlert } from "../lib/confirm-alert";

interface ConfirmTransitionState {
    isLoading: boolean;
}

const initialState: ConfirmTransitionState = {
    isLoading: false
};
const ConfirmTransitionContainer = () => {
    const [confirmTransition, setConfirmTransition] = useState(initialState);
    const history = useHistory();
    const payment = useSelector((state: AppState) => state.payment);
    const dispatch = useDispatch();

    if (
        !payment.token ||
        !payment.status?.currentPaymentPlan ||
        !payment.selectedPayment
    ) {
        return <Redirect to={URL_PATHS.paymentPlan()} />;
    }

    const subscriptionEndDate =
        payment.status == null
            ? null
            : ((payment.status.nextPaymentDate ||
                  payment.status.paidFinishDate) as string);

    /**
     * サブスクリプションを変更してカード決済に切り替えか
     * サブスクリプションはそのままでカード決済に切り替えか判断
     *
     */
    const isChangeSubscription = (): boolean => {
        const selectedSubscription = PAYMENT_PLANS.find(
            (plan) => plan.id === payment.selectedPayment.paymentPlanId
        ).subscription;
        const currentSubscription = PAYMENT_PLANS.find(
            (plan) => plan.id === payment.status.currentPaymentPlan.id
        ).subscription;
        return selectedSubscription !== currentSubscription;
    };

    async function onChangeSubscription() {
        // NOTE サブスクリプションを変更してカード決済に移行
        setConfirmTransition({ ...confirmTransition, isLoading: true });
        try {
            await agent.putPaymentCreditCardZeus({
                tokenKey: payment.token
            });
            dispatch(paymentActions.paymentTokenSet(null));
            await agent.postPaymentZeusSubscribe({
                currentPaymentState: {
                    paymentType: payment.status.paymentType as PaymentType,
                    paymentPlanId: payment.status.currentPaymentPlan.id,
                    paymentMethod: payment.status
                        .primaryPaymentMethod as PaymentMethodEnum
                },
                newPayment: payment.selectedPayment
            });
            dispatch(myDataActions.myDataShouldLoadSet(true));
            setConfirmTransition({ ...confirmTransition, isLoading: false });
            history.push(URL_PATHS.transitionFinish());
        } catch (error) {
            setConfirmTransition({ ...confirmTransition, isLoading: false });
            await smartAlert("クレジットカード決済移行に失敗しました。");
        }
    }

    async function onPaymentTransition() {
        // NOTE サブスクリプションは同じままカード決済に移行
        setConfirmTransition({ ...confirmTransition, isLoading: true });
        try {
            await agent.postTransferToCard({
                tokenKey: payment.token
            });
            dispatch(paymentActions.paymentTokenSet(null));
            dispatch(myDataActions.myDataShouldLoadSet(true));
            setConfirmTransition({ ...confirmTransition, isLoading: false });
            history.push(URL_PATHS.transitionFinish());
        } catch (error) {
            setConfirmTransition({ ...confirmTransition, isLoading: false });
            await smartAlert("クレジットカード決済移行に失敗しました。");
        }
    }

    if (payment.token === null) {
        return <Redirect to={URL_PATHS.paymentMake3DS()} />;
    }

    return (
        <ConfirmTransition
            cancellationDeadLine={dayjs(subscriptionEndDate)
                .subtract(1, "d")
                .format(DATE_FORMAT.YYYY年M月D日)}
            subscriptionEndDate={dayjs(subscriptionEndDate).format(
                DATE_FORMAT.YYYY年M月D日
            )}
            creditStartDate={dayjs(subscriptionEndDate)
                .add(1, "d")
                .format(DATE_FORMAT.YYYY年M月D日)}
            onPaymentTransition={onPaymentTransition}
            onChangeSubscription={onChangeSubscription}
            isLoading={confirmTransition.isLoading}
            isChangeSubscription={isChangeSubscription()}
            selectedPayment={payment.selectedPayment}
        />
    );
};

export default ConfirmTransitionContainer;
